import React from "react";
import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";

export default class CardAdminInsuranceTypeGeneral extends CardClass {
  /**
   * Render the content of the card.
   */
  renderContent() {
    return (
      <MUIGrid container spacing={2}>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUITextField
            value={
              this.props.insuranceType ? this.props.insuranceType.name : ""
            }
            autoFocus={true}
            size="small"
            label="Name"
            variant="standard"
            fullWidth={true}
            inputProps={{
              maxLength: 255,
            }}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) => this.props.onChange({ name: e.target.value.trim() })}
            onChange={(e) => this.props.onChange({ name: e.target.value })}
            required={true}
            error={this.props.validationIssues.name ? true : false}
            helperText={
              this.props.validationIssues.name
                ? this.props.validationIssues.name
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUITextField
            value={
              this.props.insuranceType && this.props.insuranceType.sortOrder
                ? this.props.insuranceType.sortOrder
                : ""
            }
            size="small"
            label="Ordinal"
            variant="standard"
            fullWidth={true}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) =>
              this.props.onChange({
                sortOrder: /^[\d]+$/.test(e.target.value.trim())
                  ? parseInt(e.target.value)
                  : null,
              })
            }
            onChange={(e) => this.props.onChange({ sortOrder: e.target.value })}
          />
        </MUIGrid>
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "General";
  }
}
